module.exports = __webpack_public_path__ + "img/info_lightblue.9cbf0025.svg";